module.exports = {
      id: "share-youtube-usage",
      viewBox: "0 0 44 45",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#share-youtube",
      toString: function () {
        return this.url;
      }
    }